// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../../../shared/src/Store.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var UrlHelpers = require("../../../shared/src/UrlHelpers.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var WebTypes_View = require("../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Jwt = require("../../../shared/src/types/CommonTypes_Jwt.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var Relude_AsyncData = require("relude/src/Relude_AsyncData.bs.js");
var WebGraphql_Login = require("../graphql/WebGraphql_Login.bs.js");
var WebGraphql_Cities = require("../graphql/WebGraphql_Cities.bs.js");
var WebStore_Selectors = require("./WebStore_Selectors.bs.js");
var WebStore_UserThunks = require("./thunks/WebStore_UserThunks.bs.js");
var WebStore_ShiftThunks = require("./thunks/WebStore_ShiftThunks.bs.js");
var WebStore_Types_State = require("./WebStore_Types_State.bs.js");
var WebStore_LayoutThunks = require("./thunks/WebStore_LayoutThunks.bs.js");
var WebStore_ThunkHelpers = require("./WebStore_ThunkHelpers.bs.js");
var WebStore_Types_Action = require("./WebStore_Types_Action.bs.js");
var WebStore_Reducer_Timing = require("./WebStore_Reducer_Timing.bs.js");
var WebStore_Reducer_Dashboard = require("./WebStore_Reducer_Dashboard.bs.js");
var WebStore_Reducer_PostAShift = require("./WebStore_Reducer_PostAShift.bs.js");
var CommonTypes_ResponsiveLayout = require("../../../shared/src/types/CommonTypes_ResponsiveLayout.bs.js");

function reducer(param) {
  var newBusinessAdminInfo = param[0];
  if (typeof newBusinessAdminInfo === "number") {
    switch (newBusinessAdminInfo) {
      case /* FetchCities */0 :
          return Store.sideEffects(Curry._3(WebStore_ThunkHelpers.loadAsyncData, /* NotRequired */1, WebStore_Types_Action.setCities, Curry._1(WebGraphql_Cities.Launched.queryAsyncResult, undefined)));
      case /* FetchSavedBusinessAdmins */1 :
          return WebStore_UserThunks.SideEffects.fetchSavedBusinessAdmins;
      case /* FetchSavedBusinessManagers */2 :
          return WebStore_UserThunks.SideEffects.fetchSavedBusinessManagers;
      case /* FetchSavedLocationsForCurrentUser */3 :
          return WebStore_UserThunks.SideEffects.fetchSavedLocationsForCurrentUser;
      case /* FetchUser */4 :
          return WebStore_UserThunks.SideEffects.fetchUser;
      case /* Logout */5 :
          var state = param[1];
          return Store.updateWithSideEffects({
                      cities: state.cities,
                      currentUser: /* Init */0,
                      dashboard: WebStore_Types_State.Dashboard.initialState,
                      editingShift: /* Init */0,
                      layout: state.layout,
                      postAShift: WebStore_Types_State.PostAShift.initialState,
                      savedBusinessAdmins: /* Init */0,
                      savedBusinessManagers: /* Init */0,
                      savedLocations: /* Init */0,
                      token: undefined,
                      timing: state.timing,
                      view: state.view
                    }, (function (_state, dispatch) {
                        return Relude_IO.flatMap((function (param) {
                                      return Curry._1(dispatch, WebStore_Types_Action.setView({
                                                      TAG: /* Login */3,
                                                      _0: /* Unknown */2
                                                    }));
                                    }), Relude_IO.suspend(function (param) {
                                        localStorage.removeItem("token");
                                        
                                      }));
                      }));
      case /* UpdateLayoutFromDom */6 :
          return WebStore_LayoutThunks.SideEffects.updateLayoutFromDom;
      
    }
  } else {
    switch (newBusinessAdminInfo.TAG | 0) {
      case /* AddBusinessAdmin */0 :
          return WebStore_UserThunks.SideEffects.addBusinessAdmin(newBusinessAdminInfo._0);
      case /* AddBusinessLocation */1 :
          return WebStore_UserThunks.SideEffects.addBusinessLocation(newBusinessAdminInfo._0);
      case /* AddBusinessManager */2 :
          return WebStore_UserThunks.SideEffects.addBusinessManager(newBusinessAdminInfo._0);
      case /* CommentOnShift */3 :
          return WebStore_ShiftThunks.SideEffects.commentOnShift(newBusinessAdminInfo._0, newBusinessAdminInfo._1);
      case /* Dashboard */4 :
          return WebStore_Reducer_Dashboard.reducer(param[1], newBusinessAdminInfo._0);
      case /* EditBusinessAdmin */5 :
          return WebStore_UserThunks.SideEffects.editBusinessAdmin(newBusinessAdminInfo._0);
      case /* EditBusinessLocation */6 :
          return WebStore_UserThunks.SideEffects.editBusinessLocation(newBusinessAdminInfo._0);
      case /* EditBusinessManager */7 :
          return WebStore_UserThunks.SideEffects.editBusinessManager(newBusinessAdminInfo._0);
      case /* FetchEditingShift */8 :
          return WebStore_ShiftThunks.SideEffects.fetchEditingShiftById(newBusinessAdminInfo._0);
      case /* FetchSavedLocations */9 :
          return WebStore_UserThunks.SideEffects.fetchSavedLocations(newBusinessAdminInfo._0);
      case /* FinishAddEditAdmin */10 :
          return WebStore_UserThunks.Pure.finishAddEditAdmin(param[1], Relude_AsyncData.complete(newBusinessAdminInfo._0));
      case /* FinishAddEditLocation */11 :
          return WebStore_UserThunks.Pure.finishAddEditLocation(param[1], Relude_AsyncData.complete(newBusinessAdminInfo._0));
      case /* FinishAddEditManager */12 :
          return WebStore_UserThunks.Pure.finishAddEditManager(param[1], Relude_AsyncData.complete(newBusinessAdminInfo._0));
      case /* FinishLoginBusiness */13 :
          var state$1 = param[1];
          var token = newBusinessAdminInfo._0;
          return {
                  TAG: /* UpdateWithSideEffects */2,
                  _0: {
                    cities: state$1.cities,
                    currentUser: state$1.currentUser,
                    dashboard: state$1.dashboard,
                    editingShift: state$1.editingShift,
                    layout: state$1.layout,
                    postAShift: state$1.postAShift,
                    savedBusinessAdmins: state$1.savedBusinessAdmins,
                    savedBusinessManagers: state$1.savedBusinessManagers,
                    savedLocations: state$1.savedLocations,
                    token: Caml_option.some(token),
                    timing: state$1.timing,
                    view: state$1.view
                  },
                  _1: (function (_state, dispatch) {
                      return Relude_IO.flatMap((function (param) {
                                    return Curry._1(dispatch, WebStore_Types_Action.setView({
                                                    TAG: /* BusinessDashboard */0,
                                                    _0: {
                                                      TAG: /* ShiftsList */1,
                                                      _0: /* Upcoming */1
                                                    }
                                                  }));
                                  }), Relude_IO.suspend(function (param) {
                                      localStorage.setItem("token", Curry._1(CommonTypes_Jwt.toString, token));
                                      
                                    }));
                    })
                };
      case /* FinishRemoveAdmin */14 :
          return WebStore_UserThunks.Pure.finishRemoveAdmin(param[1], Relude_AsyncData.complete(newBusinessAdminInfo._0));
      case /* FinishRemoveLocation */15 :
          return WebStore_UserThunks.Pure.finishRemoveLocation(param[1], Relude_AsyncData.complete(newBusinessAdminInfo._0));
      case /* FinishRemoveManager */16 :
          return WebStore_UserThunks.Pure.finishRemoveManager(param[1], Relude_AsyncData.complete(newBusinessAdminInfo._0));
      case /* LoginBusiness */17 :
          var state$2 = param[1];
          var password = newBusinessAdminInfo._1;
          var email = newBusinessAdminInfo._0;
          return Store.updateWithSideEffects({
                      cities: state$2.cities,
                      currentUser: state$2.currentUser,
                      dashboard: state$2.dashboard,
                      editingShift: state$2.editingShift,
                      layout: state$2.layout,
                      postAShift: state$2.postAShift,
                      savedBusinessAdmins: state$2.savedBusinessAdmins,
                      savedBusinessManagers: state$2.savedBusinessManagers,
                      savedLocations: state$2.savedLocations,
                      token: undefined,
                      timing: state$2.timing,
                      view: state$2.view
                    }, (function (state, dispatch) {
                        return Relude_IO.flatMap((function (param) {
                                      return Relude_Globals.$great$great(WebStore_Types_Action.finishLoginBusiness, dispatch, param);
                                    }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_Login.Business.mutate, {
                                            email: email,
                                            password: password
                                          }, WebStore_Selectors.getApolloClient(state))));
                      }));
      case /* NavigateToPostAShift */18 :
          var maybeCopyShiftId = newBusinessAdminInfo._0;
          return {
                  TAG: /* SideEffects */1,
                  _0: (function (_state, dispatch) {
                      return Relude_IO.flatMap((function (param) {
                                    return Curry._1(dispatch, WebStore_Types_Action.setView(WebTypes_View.postAShift(maybeCopyShiftId)));
                                  }), Curry._1(dispatch, WebStore_Types_Action.postAShift(WebStore_Types_Action.PostAShift.reset)));
                    })
                };
      case /* PostAShift */19 :
          return WebStore_Reducer_PostAShift.reducer(param[1], newBusinessAdminInfo._0);
      case /* RemoveBusinessAdmin */20 :
          return WebStore_UserThunks.SideEffects.removeBusinessAdmin(newBusinessAdminInfo._0);
      case /* RemoveBusinessLocation */21 :
          return WebStore_UserThunks.SideEffects.removeBusinessLocation(newBusinessAdminInfo._0);
      case /* RemoveBusinessManager */22 :
          return WebStore_UserThunks.SideEffects.removeBusinessManager(newBusinessAdminInfo._0);
      case /* ReviewWorker */23 :
          return WebStore_ShiftThunks.SideEffects.reviewWorker(newBusinessAdminInfo._0, newBusinessAdminInfo._1);
      case /* SetCities */24 :
          return Curry._4(WebStore_ThunkHelpers.updateAsyncResult, (function (param) {
                        return param.cities;
                      }), (function (state, cities) {
                        return {
                                cities: cities,
                                currentUser: state.currentUser,
                                dashboard: state.dashboard,
                                editingShift: state.editingShift,
                                layout: state.layout,
                                postAShift: state.postAShift,
                                savedBusinessAdmins: state.savedBusinessAdmins,
                                savedBusinessManagers: state.savedBusinessManagers,
                                savedLocations: state.savedLocations,
                                token: state.token,
                                timing: state.timing,
                                view: state.view
                              };
                      }), param[1], newBusinessAdminInfo._0);
      case /* SetUser */25 :
          return Curry._4(WebStore_ThunkHelpers.updateAsyncResult, (function (param) {
                        return param.currentUser;
                      }), (function (state, currentUser) {
                        return {
                                cities: state.cities,
                                currentUser: currentUser,
                                dashboard: state.dashboard,
                                editingShift: state.editingShift,
                                layout: state.layout,
                                postAShift: state.postAShift,
                                savedBusinessAdmins: state.savedBusinessAdmins,
                                savedBusinessManagers: state.savedBusinessManagers,
                                savedLocations: state.savedLocations,
                                token: state.token,
                                timing: state.timing,
                                view: state.view
                              };
                      }), param[1], newBusinessAdminInfo._0);
      case /* SetView */26 :
          var state$3 = param[1];
          return {
                  TAG: /* UpdateWithSideEffects */2,
                  _0: {
                    cities: state$3.cities,
                    currentUser: state$3.currentUser,
                    dashboard: state$3.dashboard,
                    editingShift: state$3.editingShift,
                    layout: state$3.layout,
                    postAShift: state$3.postAShift,
                    savedBusinessAdmins: state$3.savedBusinessAdmins,
                    savedBusinessManagers: state$3.savedBusinessManagers,
                    savedLocations: state$3.savedLocations,
                    token: state$3.token,
                    timing: state$3.timing,
                    view: newBusinessAdminInfo._0
                  },
                  _1: (function (_state, dispatch) {
                      return Curry._1(dispatch, WebStore_Types_Action.updateUrl(state$3));
                    })
                };
      case /* Timing */27 :
          return WebStore_Reducer_Timing.reducer(param[1], newBusinessAdminInfo._0);
      case /* UpdateEditingShift */28 :
          return WebStore_ShiftThunks.Pure.updateEditingShift(param[1], newBusinessAdminInfo._0);
      case /* UpdateFromUrl */29 :
          var state$4 = param[1];
          return Store.update({
                      cities: state$4.cities,
                      currentUser: state$4.currentUser,
                      dashboard: state$4.dashboard,
                      editingShift: state$4.editingShift,
                      layout: state$4.layout,
                      postAShift: state$4.postAShift,
                      savedBusinessAdmins: state$4.savedBusinessAdmins,
                      savedBusinessManagers: state$4.savedBusinessManagers,
                      savedLocations: state$4.savedLocations,
                      token: state$4.token,
                      timing: state$4.timing,
                      view: WebTypes_View.fromUrlParts(UrlHelpers.UrlParts.fromReactRouterUrl(newBusinessAdminInfo._0))
                    });
      case /* UpdateLayout */30 :
          var state$5 = param[1];
          var newLayout = newBusinessAdminInfo._0;
          if (CommonTypes_ResponsiveLayout.eq(state$5.layout, newLayout)) {
            return /* NoUpdate */0;
          } else {
            return {
                    TAG: /* Update */0,
                    _0: {
                      cities: state$5.cities,
                      currentUser: state$5.currentUser,
                      dashboard: state$5.dashboard,
                      editingShift: state$5.editingShift,
                      layout: newLayout,
                      postAShift: state$5.postAShift,
                      savedBusinessAdmins: state$5.savedBusinessAdmins,
                      savedBusinessManagers: state$5.savedBusinessManagers,
                      savedLocations: state$5.savedLocations,
                      token: state$5.token,
                      timing: state$5.timing,
                      view: state$5.view
                    }
                  };
          }
      case /* UpdateSavedBusinessAdmins */31 :
          return WebStore_UserThunks.Pure.updateSavedBusinessAdmins(param[1], newBusinessAdminInfo._0);
      case /* UpdateSavedBusinessManagers */32 :
          return WebStore_UserThunks.Pure.updateSavedBusinessManagers(param[1], newBusinessAdminInfo._0);
      case /* UpdateSavedLocations */33 :
          return Curry._4(WebStore_ThunkHelpers.updateAsyncResult, (function (param) {
                        return param.savedLocations;
                      }), (function (state, savedLocations) {
                        return {
                                cities: state.cities,
                                currentUser: state.currentUser,
                                dashboard: state.dashboard,
                                editingShift: state.editingShift,
                                layout: state.layout,
                                postAShift: state.postAShift,
                                savedBusinessAdmins: state.savedBusinessAdmins,
                                savedBusinessManagers: state.savedBusinessManagers,
                                savedLocations: savedLocations,
                                token: state.token,
                                timing: state.timing,
                                view: state.view
                              };
                      }), param[1], newBusinessAdminInfo._0);
      case /* UpdateUrl */34 :
          var previousState = newBusinessAdminInfo._0;
          return {
                  TAG: /* SideEffects */1,
                  _0: (function (state, _dispatch) {
                      return Curry._2(Relude_IO.mapError, (function (param) {
                                    return Store.$$void;
                                  }), DomUtils.Router.pushUrl(WebStore_Selectors.getUrl(previousState), WebStore_Selectors.getUrl(state)));
                    })
                };
      
    }
  }
}

function reducer$1(param, param$1) {
  return Relude_Globals.flip((function (param, param$1) {
                return Relude_Function.curry2(reducer, param, param$1);
              }), param, param$1);
}

var Layout;

var Selectors;

var Shift;

var User;

exports.Layout = Layout;
exports.Selectors = Selectors;
exports.Shift = Shift;
exports.User = User;
exports.reducer = reducer$1;
/* Store Not a pure module */
